import { User } from "firebase/auth";
import { useMemo } from "react";

// 파일 업로드 가능 여부를 로그인 상태 기준으로 계산해 UI 경고 문구와 함께 반환한다.
export function useFirebaseUploadGuard(user: User | null) {
  return useMemo(() => {
    const canUpload = !!user;
    return {
      canUpload,
      reason: canUpload ? "" : "Popup/IR 파일 업로드는 Firebase 로그인 상태에서만 가능합니다.",
    };
  }, [user]);
}
